import { Button, CircularProgress, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import Chart from "react-google-charts";
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useAppSelector } from '../../app/hooks';
import { getProjectDetails, getProjectState, getFanDetails, getFetching, getFetchingError, createNewProject, getDrafts, getProjects, changeRPM, getFanData, resetFanStore, getGADetails } from '../../app/reducer/project.reducer';

import AlertComponent from "../general/Alert";

export default function CampbellDiagram({...props}:any) {
  
  const [graphData, setGraphData] = React.useState<any[]>([]);
  const dispatch = useDispatch();
  const history = useHistory();

  const [openErrAlert, setOpenErrAlert] = React.useState<boolean>(false);

  const projectState = useAppSelector(getProjectState);

  const projectDetails = useAppSelector(getProjectDetails);
  const fanDetails = useAppSelector(getFanDetails);
  const gaDetails = useAppSelector(getGADetails);
  const fan = useAppSelector(getFanData);
  const projBusy = useAppSelector(getFetching);
  const fetchingErr = useAppSelector(getFetchingError);

  /*const saveProject = async () => {
    let data = {...projectDetails, fan_form: fanDetails, fan_details: fan};
    if(gaDetails){
      data.ga_details = gaDetails;
    }
    await dispatch((data))
    if(fetchingErr===false){
      dispatch(getDrafts());
      dispatch(getProjects());
      dispatch(resetFanStore());
      history.push('/projects');
    }else{
      setOpenErrAlert(true);
    }

  }*/

  
  const saveProject = async () => {
    console.log('saveProject')
    let data = { ...projectDetails, fan_form: fanDetails, fan_details: fan };
    if (gaDetails) {
      data.ga_details = gaDetails;
    };
    await dispatch(createNewProject(data));

    if (fetchingErr === false) {
      dispatch(getDrafts());
      dispatch(getProjects());
      dispatch(resetFanStore());
      history.push('/projects');
    } else {
      setOpenErrAlert(true)
    }
  }
  
  useEffect(() => {

    populateGraphDataFromProps()

  }, [props.data]);

  const onPlotpointChage = (value:number) => {

    dispatch(changeRPM(value))

  }
  
  const populateGraphDataFromProps = async () => {

    const { data } = props;

    let tempGraphData = [];

    let graphHeaderData = ['RPM', 'Fan Operation Freq', 'Blade Pass Freq', 'Beam Pass Freq', 'Mode 1 NF', 'Operating NF'];
    
    tempGraphData.push(graphHeaderData);
    let rpm = fanDetails.fan_speed?fanDetails.fan_speed:fan.rpm;
    // console.log(fanDetails,fan)
    // let rpm2 =fan_form.rpm ?fan_form.rpm:fanDetails.rpm;
    console.log(rpm,fanDetails,fan);
    let RotFreq = rpm/60;
    let BladePassFreq = rpm/(60/fan?.numofBlades); // number of blades should be thereis the place of 6 from fan upload data.
    let BeamPassFreq = rpm/(60/fanDetails?.beam_no); // if number of beam is not being passed use 4 as a fallback.
    let Mode1NF =  fan.bladeModel.bladeFreqMode1;
    
    let factorArr = [ 0.1,0.2,0.3,0.4,0.5,0.6,0.7,0.8,0.9,1]
    
    for (let i = 0; i < factorArr.length; i++) {
      
      let GraphDataRow = [];
      
      let OperatingNF =(Math.sqrt(Math.pow(Mode1NF, 2) + (1.5 * rpm*factorArr[i] / 60)));;
      GraphDataRow.push((rpm*factorArr[i]).toFixed(2));
      GraphDataRow.push(RotFreq*factorArr[i]);
      GraphDataRow.push(BladePassFreq*factorArr[i]);
      GraphDataRow.push(BeamPassFreq*factorArr[i]);
      GraphDataRow.push(Mode1NF); 
      GraphDataRow.push(OperatingNF);

      tempGraphData.push(GraphDataRow);
      
    }

    setGraphData(tempGraphData);

  }

  if(props.onlyGraph){
    return(
      <Chart
          width={'100%'}
          height={'700px'}
          chartType="LineChart"
          loader={<div>Loading Chart</div>}
          data={
            graphData
            // [
            //   ['RPM','Blade Pass Freq','Beam Pass Freq','Mode 1 NF','Operating NF','Fan Operation NF'],
            //   [ 0, 0,	0, 0,	5.6, 6.067, ],
            //   [ 21.8,	0.36,	2.18, 1.45,	5.6, 6.068 ],
            //   [ 43.6,	0.73,	4.36, 2.91,	5.6, 6.069 ],
            //   [ 65.4,	1.09,	6.54, 4.36,	5.6, 6.07 ],
            //   [ 87.2,	1.45,	8.72, 5.81,	5.6, 6.071 ],
            //   [ 109.,	1.82,	10.9, 7.27,	5.6, 6.072 ],
            //   [ 130.8, 2.18,	13.08, 8.72,	5.6, 6.073 ],
            //   [ 152.6, 2.54,	15.26, 10.17, 5.6, 6.074 ],
            //   [ 174.4, 2.91,	17.44, 11.63, 5.6, 6.075 ],
            //   [ 196.2, 3.27,	19.62, 13.08, 5.6, 6.076 ],
            //   [ 218, 3.63, 21.8, 14.53, 5.6, 6.077, ],
            // ]
          }
          options={{
            legend: {
    textStyle: {
      fontSize: 17, // 🔥 increase this
    },
  },
            hAxis: {
              title: 'RPM',
              textStyle: {
        fontSize: 22, // 🔹 x-axis labels
      },
      titleTextStyle: {
        fontSize: 18, // 🔹 x-axis title
        bold: true,
      },
            },
            vAxis: {
              title: 'Frequency (Hz)',
              textStyle: {
        fontSize: 22, // 🔹 x-axis labels
      },
      titleTextStyle: {
        fontSize: 18, // 🔹 x-axis title
        bold: true,
      },
            },
            series: {
              1: { curveType: 'function' }
            },
          }}
        />
    )
  }else{
    return (
      <div style={{
        display:'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '1011px',
        padding: '50px'
      }}>
        <Typography variant="h5" gutterBottom>
          <b>Campbell Diagram</b>
        </Typography>
        <Chart
          width={'100%'}
          height={'400px'}
          chartType="LineChart"
          loader={<div>Loading Chart</div>}
          data={
            graphData
            // [
            //   ['RPM','Blade Pass Freq','Beam Pass Freq','Mode 1 NF','Operating NF','Fan Operation NF'],
            //   [ 0, 0,	0, 0,	5.6, 6.067, ],
            //   [ 21.8,	0.36,	2.18, 1.45,	5.6, 6.068 ],
            //   [ 43.6,	0.73,	4.36, 2.91,	5.6, 6.069 ],
            //   [ 65.4,	1.09,	6.54, 4.36,	5.6, 6.07 ],
            //   [ 87.2,	1.45,	8.72, 5.81,	5.6, 6.071 ],
            //   [ 109.,	1.82,	10.9, 7.27,	5.6, 6.072 ],
            //   [ 130.8, 2.18,	13.08, 8.72,	5.6, 6.073 ],
            //   [ 152.6, 2.54,	15.26, 10.17, 5.6, 6.074 ],
            //   [ 174.4, 2.91,	17.44, 11.63, 5.6, 6.075 ],
            //   [ 196.2, 3.27,	19.62, 13.08, 5.6, 6.076 ],
            //   [ 218, 3.63, 21.8, 14.53, 5.6, 6.077, ],
            // ]
          }
          options={{
            hAxis: {
              title: 'RPM',
            },
            vAxis: {
              title: 'Frequency (Hz)',
            },
            series: {
              1: { curveType: 'function' }
            },
          }}
        />
        <br/>
        <div
        style={{
          display:'flex',
          flexDirection:'row',
          justifyContent:'flex-start'
        }}>
          {projectState!=="saved" && <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={()=>saveProject()}
                  disabled={projBusy}
          >
            {projBusy?
            <CircularProgress 
            size={26}
            />:"Save Project"}
          </Button>}
          <Button
              variant="outlined"
              // color="primary"
              size="large"
              style={{color:'white',marginLeft:'20px',backgroundColor:'#6b6666'}}
              onClick={e=>props.setIndex(4)}
          >
              Back
          </Button>
          <Button
              variant="contained"
              color="primary"
              size="large"
              style={{marginLeft:'20px'}}
              onClick={e=>props.setIndex(6)}
          >
              Next
          </Button>
        </div>
          <AlertComponent open={openErrAlert} message="Something went wrong. Please Try again." severity="error" handleClose={()=>{setOpenErrAlert(false)}} />
      </div>
    );
  }
}
